const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let pageSize;
let { deletePets } = require('./services.blop');
let { getPets } = require('./services.blop');

let classes = require('./style.scss');

pageSize = 10;

function pagination(petStore) {let pets, pageIndex, nbPage, nextPage, previousPage, __4, __5;
  pets = petStore.pets;
  pageIndex = petStore.pageIndex;
  nbPage = Math.ceil(pets.length / pageSize);
  nextPage = (e) => {
    e.preventDefault();
    petStore.pageIndex += 1
  };
  previousPage = (e) => {
    e.preventDefault();
    petStore.pageIndex -= 1
  };
  const __1c = []; const __1a = {}; __1a['class'] = 'pagination';
    if (pageIndex > 0) {
      const __2c = []; const __2a = {}; __2a['href'] = '#'; __2a['class'] = `btn btn-outline-secondary btn-sm ${classes.previous}`; __2a['on'] = ({ click: previousPage }); const __3 = '< Previous page'; Array.isArray(__3) ? __2c.push(...__3) : __2c.push(__3); const __2 = blop.h('a', __2a, __2c); __1c.push(__2);
      __4 = ' '; Array.isArray(__4) ? __1c.push(...__4) : __1c.push(__4); ;
    }
    __5 = `Page ${pageIndex + 1} on ${nbPage} `; Array.isArray(__5) ? __1c.push(...__5) : __1c.push(__5); ;
    if (pageIndex < pets.length) {
      const __6c = []; const __6a = {}; __6a['href'] = '#'; __6a['class'] = `btn btn-outline-secondary btn-sm ${classes.next}`; __6a['on'] = ({ click: nextPage }); const __7 = 'Next page >'; Array.isArray(__7) ? __6c.push(...__7) : __6c.push(__7); const __6 = blop.h('a', __6a, __6c); __1c.push(__6);
    }
   const __1 = blop.h('p', __1a, __1c); return __1;
};

function PetStore(attributes, _chilren, node) {let petStore, pets, pageIndex, start, page, controller, deletePet, __10, __13, __18, __24, __29;
  let { state } = attributes;
  petStore = state.petStore;
  pets = petStore.pets;
  pageIndex = petStore.pageIndex;
  start = pageIndex * pageSize;
  page = petStore.pets.slice(start, (pageIndex + 1) * pageSize);
  controller = null;

  node.mount(() => {
    console.log('mount PetStore');
    controller = getPets(state);
  });

  node.unmount(() => {
    console.log('unmount PetStore');
    controller ? controller.abort() : undefined;
  });

  deletePet = (index, pet) =>() => {
    deletePets(pet);
    pets.splice(start + index, 1);
  };
  const __8c = []; const __8a = {}; __8a['class'] = classes.petstore;
    const __9c = []; const __9a = {};
      __10 = `Using the slow and buggy swagger pet API is a good test. Rendering ${pets.length} pets from `; Array.isArray(__10) ? __9c.push(...__10) : __9c.push(__10); ;
      const __11c = []; const __11a = {}; __11a['href'] = 'https://petstore.swagger.io/'; const __12 = 'petstore.swagger.io'; Array.isArray(__12) ? __11c.push(...__12) : __11c.push(__12); const __11 = blop.h('a', __11a, __11c); __9c.push(__11);
     const __9 = blop.h('p', __9a, __9c); __8c.push(__9);
    if (petStore.pets.length) {
      __13 = pagination(petStore); Array.isArray(__13) ? __8c.push(...__13) : __8c.push(__13); ;
      const __14c = []; const __14a = {}; __14a['class'] = 'table';
        let __15 = page; let key=0; for(; key < __15.length; key++) { let pet = __15[key];
          // the key can help with the patching speed
          const __16c = []; const __16a = {}; __16a['key'] = key;
            const __17c = []; const __17a = {};
              __18 = pet.name; Array.isArray(__18) ? __17c.push(...__18) : __17c.push(__18); ;
             const __17 = blop.h('td', __17a, __17c); __16c.push(__17);
            const __19c = []; const __19a = {};
              if (pet.photoUrls) {
                let __21 = pet.photoUrls; let __22 = Object.keys(__21); let _i__20; for(let __23=0; __23 < __22.length; __23++) { _i__20 = __22[__23]; let src = __21[_i__20];
                  __24 = src.startsWith('http') ? (() => {const __25c = []; const __25a = {}; __25a['src'] = src; __25a['style'] = ({ width: '100px', height: '100px' }); const __25 = blop.h('img', __25a, __25c); return __25;})() : undefined; Array.isArray(__24) ? __19c.push(...__24) : __19c.push(__24); ;
                };
              }
             const __19 = blop.h('td', __19a, __19c); __16c.push(__19);
            const __26c = []; const __26a = {};
              const __27c = []; const __27a = {}; __27a['class'] = 'btn btn-outline-danger btn-sm'; __27a['on'] = ({ click: deletePet(key, pet) }); const __28 = 'Delete'; Array.isArray(__28) ? __27c.push(...__28) : __27c.push(__28); const __27 = blop.h('button', __27a, __27c); __26c.push(__27);
             const __26 = blop.h('td', __26a, __26c); __16c.push(__26);
           const __16 = blop.h('tr', __16a, __16c); __14c.push(__16);
        };
       const __14 = blop.h('table', __14a, __14c); __8c.push(__14);
      __29 = pagination(petStore); Array.isArray(__29) ? __8c.push(...__29) : __8c.push(__29); ;
    } else {
      const __30c = []; const __30a = {}; __30a['class'] = 'spinner-border text-primary'; __30a['role'] = 'status';
        const __31c = []; const __31a = {}; __31a['class'] = 'sr-only'; const __32 = 'Loading...'; Array.isArray(__32) ? __31c.push(...__32) : __31c.push(__32); const __31 = blop.h('span', __31a, __31c); __30c.push(__31);
       const __30 = blop.h('div', __30a, __30c); __8c.push(__30);
    }
   const __8 = blop.h('div', __8a, __8c); return __8;
};

module.exports = { deletePets, getPets, classes, pageSize, pagination, PetStore };
